<div class="autocomplete-container">
  <label class="form-label">{{ 'Adresse' | tekstresource }}</label>
  <input
    #input
    type="text"
    class="form-input"
    [placeholder]="'SkrivAdresse' | tekstresource"
    [disabled]="disabled"
  />
</div>
